import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/carPlateMatchRule/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/carPlateMatchRule/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/carPlateMatchRule/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/carPlateMatchRule/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/carPlateMatchRule/update', params,options);

export const sync = (params, options) =>
  request.post('/api/v4ward/carPlateMatchRule/sync', qs.stringify(params),options);

export const updateStatus = (params, options) =>
  request.post('/api/v4ward/carPlateMatchRule/updateStatus', params,options);

export const getCarParkList = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/getCarParkList', Object.assign({}, options, { params }));
